import { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'

import { PostSection } from 'src/features/feeds/components/feeds/post-section'
import { useUserByUsername } from 'src/shared/features/users/api/accounts/use-user-by-username'
import { useUserPrivacyPreferences } from 'src/shared/features/users/api/preferences/use-user-privacy-preferences'
import UserFeedList from 'src/shared/features/users/components/public-profile/feed/user-feed-list'
import ListingList from 'src/shared/features/users/components/public-profile/listings/listing-list'
import PortfolioList from 'src/shared/features/users/components/public-profile/portfolio/portfolio-list'
import ReviewList from 'src/shared/features/users/components/public-profile/reviews/review-list'
import RightContentContainer from 'src/shared/features/users/components/public-profile/right-content-container'
import PublicProfileReviewsSection from 'src/shared/features/users/components/public-profile/section/reviews'
import PublicProfileTransactionsSection from 'src/shared/features/users/components/public-profile/section/transactions'
import PublicProfileSectionHeader from 'src/shared/features/users/components/public-profile/section-header'
import { usePublicProfileStore } from 'src/shared/features/users/components/public-profile/stores/use-public-profile-store'
import { useMobilePublicProfileStore } from 'src/shared/features/users/stores/mobile-public-profile-store'
import { useWindowSize } from 'src/shared/hooks/use-window-size'

export const ProfileSectionsContainer = ({ userId, isPublic = false }: { userId: number; isPublic?: boolean }) => {
  const { activeTab, setIsPublicProfile } = usePublicProfileStore()
  const { data: preferences } = useUserPrivacyPreferences(userId)

  useEffect(() => {
    setIsPublicProfile(isPublic)
  }, [setIsPublicProfile, isPublic])

  const showActivity = preferences?.postsVisibleToConsumer

  return (
    <div className="flex w-full flex-col gap-4">
      <PublicProfileSectionHeader userId={userId} />
      {activeTab === 'activity' && showActivity && (
        <div className="-mt-8 w-full text-clip">
          <PostSection userId={userId} isPublic={isPublic} />
        </div>
      )}
      {activeTab === 'reviews' && (
        <div className="w-full text-clip">
          <PublicProfileReviewsSection userId={userId} />
        </div>
      )}
      {activeTab === 'transactions' && (
        <div className="w-full text-clip">
          <PublicProfileTransactionsSection userId={userId} />
        </div>
      )}
    </div>
  )
}

const PublicUserProfile = () => {
  const { username } = useParams<{ username: string }>()
  const { data: user } = useUserByUsername(username || '')
  const navigate = useNavigate()
  const { activeTab } = useMobilePublicProfileStore()
  const { width } = useWindowSize()

  if (!user) {
    navigate('/404')
    return null
  }

  if (width < 768) {
    return (
      <>
        <meta name="theme-color" content="#f8f7f5" />
        <RightContentContainer>
          {activeTab === 'listings' && (
            <ListingList showAll={true} firstName={user.firstName} username={username as string} />
          )}
          {activeTab === 'reviews' && (
            <ReviewList
              showAll={true}
              mobile
              userId={user.id}
              username={username as string}
              firstName={user.firstName}
            />
          )}
          {activeTab === 'portfolio' && (
            <PortfolioList
              showAll={true}
              mobile
              userId={user.id}
              username={username as string}
              firstName={user.firstName}
              profession={user.profession}
            />
          )}
          {activeTab === 'activity' && <UserFeedList mobile userId={user.id} firstName={user.firstName} />}
        </RightContentContainer>
      </>
    )
  }

  return (
    <>
      <meta name="theme-color" content="#f8f7f5" />
      <RightContentContainer>
        {/* <ListingList firstName={user.firstName} username={username as string} /> */}
        <ReviewList userId={user.id} username={username as string} firstName={user.firstName} />
        <PortfolioList
          userId={user.id}
          username={username as string}
          profession={user.profession}
          firstName={user.firstName}
        />
        <UserFeedList userId={user.id} firstName={user.firstName} />
      </RightContentContainer>
    </>
  )
}

export default PublicUserProfile
